"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DarkText = _interopRequireDefault(require("../../DarkText"));

var _DarkRadio = _interopRequireDefault(require("../../DarkRadio"));

var _OptionsImage = _interopRequireDefault(require("./components/OptionsImage"));

var _DarkButton = _interopRequireDefault(require("../../Button/DarkButton"));

var _styles = require("./styles");

var _consts = require("./consts");

var _styles2 = require("../PollTeacher/common/styles");

var _IconComplete = _interopRequireDefault(require("../../Icons/IconComplete"));

// import CloseButton from './components/CloseButton';
function PollLearner(props) {
  var _props$classname = props.classname,
      classname = _props$classname === void 0 ? '' : _props$classname,
      poll = props.poll,
      dispatch = props.dispatch,
      activePollsCount = props.activePollsCount;
  var options = poll.options;
  var optionsKeys = Object.keys(options);

  var _useState = (0, _react.useState)(poll.responseId),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      responseId = _useState2[0],
      setResponseId = _useState2[1];

  var onClose = function onClose() {
    dispatch({
      type: _consts.PollLearnerActions.CLOSE_POLL,
      payload: {
        pollId: poll.pollId
      }
    });
  };

  var onSubmit = function onSubmit() {
    dispatch({
      type: _consts.PollLearnerActions.SUBMIT_POLL,
      payload: {
        pollId: poll.pollId,
        responseId: responseId
      }
    });
  };

  var isSubmitted = poll.responseId;
  var showResults = poll.showResults;
  var sum = optionsKeys.map(function (key) {
    return options[key].responses;
  }).reduce(function (prev, curr) {
    return prev + curr;
  }, 0);
  var maxResponses = Math.max.apply(Math, (0, _toConsumableArray2.default)(optionsKeys.map(function (key) {
    return options[key].responses;
  })));
  var multipleMax = showResults && optionsKeys.filter(function (key) {
    return options[key].responses === maxResponses;
  }).length > 1;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)((0, _styles.pollLearnerRoot)(isSubmitted), 'poll-learner', classname)
  }, _react.default.createElement(_DarkText.default, {
    letterSpacing: 1.5,
    fontSize: 14,
    color: "zinc",
    uppercase: true
  }, "Poll ", activePollsCount > 1 ? "(1 of ".concat(activePollsCount, ")") : ''), _react.default.createElement(_DarkText.default, {
    fontSize: 26,
    className: "poll-question"
  }, poll.question), _react.default.createElement("div", {
    className: "poll-options"
  }, optionsKeys.map(function (key) {
    var option = options[key];
    var imageUrl = option.imageUrl;

    if (isSubmitted) {
      var percentSelected = showResults && sum > 0 && option.responses > 0 && Math.round(option.responses / sum * 100) || 0;
      var isMaximum = showResults && maxResponses && option.responses ? option.responses === maxResponses : false;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _styles.pollSubmited)(percentSelected, isSubmitted, imageUrl, showResults), _styles2.flexAlignCenterStretch, 'option', {
          maximum: isMaximum
        }, {
          multipleMaximum: multipleMax
        })
      }, _react.default.createElement("div", {
        className: "option-bar-wrapper"
      }, _react.default.createElement("div", {
        className: "option-bar"
      }, _react.default.createElement("div", {
        className: "poll-option-submitted"
      }), _react.default.createElement("div", {
        className: "poll-option-text"
      }, _react.default.createElement(_DarkText.default, {
        color: isMaximum && !multipleMax ? 'saturn' : 'silver',
        className: (0, _classnames.default)('option-text', _styles.pollText)
      }, _react.default.createElement(_OptionsImage.default, {
        option: option,
        isSubmitted: isSubmitted
      }), _react.default.createElement("div", {
        className: "text"
      }, option.text)), responseId === key ? _react.default.createElement(_IconComplete.default, null) : null))), showResults && _react.default.createElement(_DarkText.default, {
        color: isMaximum ? 'copper' : 'cobalt',
        className: "option-percent"
      }, percentSelected, " %"));
    }

    return _react.default.createElement(_DarkRadio.default, {
      key: key,
      value: key,
      label: _react.default.createElement(_DarkText.default, {
        className: _styles.pollText,
        as: "div"
      }, _react.default.createElement(_OptionsImage.default, {
        option: option,
        isSubmitted: isSubmitted
      }), _react.default.createElement("div", {
        className: "text"
      }, option.text)),
      onChange: function onChange(e) {
        return setResponseId(e.target.value);
      },
      className: (0, _classnames.default)('poll-option', (0, _styles.pollOption)(option.imageUrl)),
      checked: responseId === key,
      disabled: isSubmitted
    });
  })), isSubmitted ? _react.default.createElement(_DarkButton.default.SecondaryButton, {
    onClick: onClose,
    disabled: !responseId,
    className: "poll-done"
  }, "Close") : _react.default.createElement(_DarkButton.default, {
    onClick: onSubmit,
    disabled: !responseId,
    className: "poll-submit"
  }, "Submit"));
}

var _default = PollLearner;
exports.default = _default;